interface ModelInfoBadgeProps {
  displayName: string;
  tier: string;
}

const TIER_COLORS: Record<string, string> = {
  fast: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
  balanced: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
  powerful: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
};

export function ModelInfoBadge({ displayName, tier }: ModelInfoBadgeProps) {
  const colorClass = TIER_COLORS[tier] || TIER_COLORS.balanced;

  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium ${colorClass}`}
    >
      {displayName}
    </span>
  );
}
